import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 14 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4 2C4 1.17157 4.67157 0.5 5.5 0.5H12.25C13.0784 0.5 13.75 1.17157 13.75 2V11.75C13.75 12.5784 13.0784 13.25 12.25 13.25H10.75V14C10.75 14.8284 10.0784 15.5 9.25 15.5H1.75C0.921573 15.5 0.25 14.8284 0.25 14V6.43226L4 2.90447V2ZM3.70684 5.23969L2.89182 6.00642H3.70477V7.50642H1.75V14H9.25V4.25H5.20952L5.20477 6.01046C5.20254 6.83731 4.53162 7.50642 3.70477 7.50642V6.00642L3.70684 5.23969ZM5.5 2.75V2H12.25V11.75H10.75V4.25C10.75 3.42157 10.0784 2.75 9.25 2.75H5.5ZM2.5 9.5C2.5 9.08579 2.83579 8.75 3.25 8.75H7.75C8.16421 8.75 8.5 9.08579 8.5 9.5C8.5 9.91421 8.16421 10.25 7.75 10.25H3.25C2.83579 10.25 2.5 9.91421 2.5 9.5ZM2.5 11.75C2.5 11.3358 2.83579 11 3.25 11H7.75C8.16421 11 8.5 11.3358 8.5 11.75C8.5 12.1642 8.16421 12.5 7.75 12.5H3.25C2.83579 12.5 2.5 12.1642 2.5 11.75Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}